import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

/**
 * Creates a reusable SVG component with consistent base properties and forwarded refs.
 *
 * @description
 * The component automatically sets up proper viewBox and xmlns attributes while
 * allowing all standard SVG properties to be passed through.
 *
 * @example
 * const IconCheck = createSVG({
 *   children: (
 *     <path
 *       d="M20 6L9 17L4 12"
 *       stroke="currentColor"
 *       strokeWidth={2}
 *       strokeLinecap="round"
 *     />
 *   ),
 * });
 *
 * const MyComponent = () => (
 *   <IconCheck
 *     className="text-blue-500"
 *     width={32}
 *     height={32}
 *   />
 * );
 */
function createSVG({ children, width = 24, height = 24 }) {
    return forwardRef(({ ...props }, ref) => (jsx("svg", { width: width, height: height, fill: "none", viewBox: `0 0 ${width} ${height}`, xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: children })));
}

export { createSVG };
